<template>
  <div id="custom-cursor">
    <div
      @mousedown="hover = true"
      v-for="n in 3"
      :key="n"
      class="cursor"
      :style="{ left: `${mouseX}px`, top: `${mouseY}px` }"
      :class="{ hover: (hover && n != 1) || pulse }"
    ></div>
  </div>
</template>

<script>
import { EventBus } from "../main";
export default {
  props: {
    pulse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mouseX: "",
      mouseY: "",
      hover: false
    };
  },
  methods: {
    addHover(links) {
      for (let link of links) {
        link.addEventListener("mouseover", () => {
          this.hover = true;
        });
        link.addEventListener("mouseout", () => {
          this.hover = false;
        });
      }
    },
    positionElement(position) {
      this.mouseX = position.clientX;
      this.mouseY = position.clientY;
    }
  },
  mounted() {
    EventBus.$on("allLinks", links => {
      this.addHover(links);
    });

    window.onmousemove = event => {
      let _event = event;
      this.positionElement(_event);
    };
  }
};
</script>

<style lang="scss" scoped>
.cursor {
  position: fixed;
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%);
  pointer-events: none;
  left: -36px;
  top: -36px;
  backface-visibility: hidden;
}
.cursor:first-of-type {
  background-color: #fff;
  height: 0;
  width: 0;
  z-index: 99999;
}
.cursor:not(:first-of-type) {
  height: 36px;
  width: 36px;
  z-index: 99998;
  transition: transform 0.3s ease-out;

  &.hover {
    transform: scale(2) translateX(-25%) translateY(-25%);
    border: none;
  }
}

.cursor:nth-of-type(2) {
  border: 2px solid #fff;
  box-shadow: 0 0 22px rgba(255, 255, 255, 0.6);

  &.hover {
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
  }
}

.scale-up .cursor:not(:first-of-type) {
  opacity: 0;
}

.cursor-dark .cursor:not(:first-of-type) {
  border: 2px solid #4b4d64;
  box-shadow: 0 0 14px rgba(75, 77, 100, 0.3);
}
.cursor-dark .cursor:not(:first-of-type):hover {
  background: rgba(75, 77, 100, 0.3);
  border: none;
  box-shadow: 0 0 14px rgba(75, 77, 100, 0.2);
}

.video-cursor .cursor:not(:first-of-type).hover {
  opacity: 0;
}

@media screen and (max-width: 1200px) {
  .cursor {
    display: none;
  }
}
</style>
